import React, { useState, useEffect } from 'react';

const students = [
  {
    name: 'Money Manifestation',
    title: "Anil's Manifestation Journey",
    videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    earnings: '50 Lakh Manifested',
    icon: '💰'
  },
  {
    name: 'Relationship Manifestation',
    title: "Kanchan's Manifestation Journey",
    videoUrl: 'https://www.youtube.com/embed/tgbNymZ7vqY',
    earnings: 'Manifested Marriage',
    icon: '💍'
  },
  {
    name: 'Health Manifestation',
    title: "Rameshwar's Manifestation Journey",
    videoUrl: 'https://www.youtube.com/embed/9bZkp7q19f0',
    earnings: 'Improved Health',
    icon: '📝'
  }
];

const TopStudents = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ background: '#f1e7e7', padding: '60px 20px', fontFamily: 'Outfit, sans-serif' }}>
      <h2 style={{
        textAlign: 'center',
        fontSize: '32px',
        marginBottom: '70px',
        color: '#333333'
      }}>
        Success Stories from Past Participants
      </h2>

      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '30px'
      }}>
        {students.map((student, index) => (
          <div key={index} style={{
            width: '320px',
            backgroundColor: '#0c1530',
            borderRadius: '20px',
            color: 'white',
            overflow: 'hidden',
            textAlign: 'center',
            paddingBottom: '20px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            position: 'relative'
          }}>
            {/* YouTube Video */}
            <div style={{
              width: '100%',
              height: '180px',
              marginBottom: '10px',
              marginTop: '15px'
            }}>
              <iframe
                width="80%"
                height="180"
                src={student.videoUrl}
                title={student.name}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  borderRadius: '20px',
                  border: '1px solid #fff'
                }}
              ></iframe>
            </div>

            {/* Name & underline */}
            <h3 style={{ margin: '20px 0 4px', fontSize: '20px' }}>
              {student.name}
            </h3>
            <div style={{
              width: '60px',
              height: '2px',
              background: '#fff',
              margin: '0 auto 10px'
            }}></div>

            <p style={{ margin: '0 0 20px', fontSize: '14px', color: '#fff' }}>
              {student.title}
            </p>

            {/* Earnings Badge */}
            <div style={{
              border: '1px dashed rgba(255,255,255,0.4)',
              borderRadius: '12px',
              margin: '0 auto',
              padding: '10px 20px',
              fontWeight: 'bold',
              fontSize: '16px',
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              backgroundColor: '#0c1530'
            }}>
              <span>{student.icon}</span> {student.earnings}
            </div>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <button style={{
          background: 'linear-gradient(49.12deg, #ffc74b 0, #e39600 22%)',
          color: 'white',
          fontSize: isMobile ? '18px' : '20px',
          padding: isMobile ? '10px 40px' : '25px 80px',
          border: 'none',
          borderRadius: '20px',
          fontWeight: 'bold',
          cursor: 'pointer',
          width: isMobile ? '100%' : 'auto',
        }}>
          Join The 2 Day Workshop for ₹199 &nbsp;
          <span style={{ textDecoration: 'line-through', opacity: 0.8 }}>₹999</span>
        </button>

        <p style={{
          marginTop: '10px',
          color: 'black',
          fontSize: '16px',
          fontFamily: 'Outfit, sans-serif',
          fontStyle: 'italic'
        }}>
         <span style={{fontWeight:'600'}}> Registrations End on</span> <span style={{ fontWeight: 'bold', color: 'red' }}>11 JUL</span> <br />
         <span style={{fontWeight:'600'}}> 100% </span> मनी बॅक गॅरंटी | समाधानी नसल्यास
        </p>
      </div>
    </div>
  );
};

export default TopStudents;
